import { MULTI_SELECT_STORAGE_KEY } from "@/redux/slices/property";

// Single-select pages remember the last-picked property per tab so
// returning to the list redirects straight back in. Keyed here (not as a
// literal in the page) so signOut can clear it alongside the multi-select
// state without the page needing to know about auth. OTA Audits is the only
// page using this today — Events doesn't persist a selection yet, but its
// key is reserved here so clearPersistedPropertySelections() won't need a
// signOut-path change whenever it starts.
export const OTA_AUDITS_PROPERTY_STORAGE_KEY = "ota-audits:propertyId";
export const EVENTS_PROPERTY_STORAGE_KEY = "events:propertyId";

// sessionStorage survives the full-page redirect Keycloak does on
// login/logout (same tab), so without this a second user signing in on the
// same tab inherits the previous user's property selection and gets 403s
// for properties they don't have access to.
export function clearPersistedPropertySelections() {
  try {
    sessionStorage.removeItem(MULTI_SELECT_STORAGE_KEY);
    sessionStorage.removeItem(OTA_AUDITS_PROPERTY_STORAGE_KEY);
    sessionStorage.removeItem(EVENTS_PROPERTY_STORAGE_KEY);
  } catch {
    // sessionStorage unavailable (e.g. private browsing quota) — nothing to clear.
  }
}
